import { TokenCell } from "../../../components/grid/cells/TokenCell";
import { BoolFilter } from "../../../components/inputs/BoolFilter";
import { Toolbar } from "../../../components/Toolbar";
import { AdministrateBackgroundExportButton } from "../../components/AdministrateBackgroundExportButton";
import { AdministrateTable } from "../../components/AdministrateTable";
import { PayorOptionsFilter } from "../../components/filters/PayorOptionsFilter";
import { NetworkStatusCell } from "../../payors/components/NetworkStatusCell";
import { makeColumns, UPDATE, useAdministrateTable, useCreatePermission } from "../../utils";
import { ImportLabPayorSettingsModal } from "../components/ImportLabPayorSettingsModal";
import { LabPayorNetworkStatusActionCell } from "../components/LabPayorNetworkStatusActionCell";

const useColumns = makeColumns(({ labId, labName }) => [
  {
    id: "associated_payor_id",
    accessor: "payorId",
    Header: "Payor Id",
    disableSortBy: true,
    disableFilters: true,
    Cell: TokenCell,
  },
  {
    id: "payor_id",
    accessor: "payorName",
    Header: "Payor",
    disableSortBy: true,
    Filter: (props) => <PayorOptionsFilter {...props} />,
  },
  {
    id: "in_network",
    accessor: "inNetwork",
    Header: "Network Status",
    Cell: NetworkStatusCell,
    disableSortBy: true,
    Filter: (props) => <BoolFilter {...props} yesLabel="In-Network" noLabel="Out-of-Network" />,
  },
  {
    id: "actions",
    Header: "Actions",
    Cell: ({ row }) => <LabPayorNetworkStatusActionCell labId={labId} labName={labName} {...row} />,
    disableFilters: true,
    disableSortBy: true,
  },
]);

export const LabsPayorsNetworkStatusTab = ({ labId, lab }) => {
  const { tableRef, allFilters, setTableFilters } = useAdministrateTable();
  const [canCreate] = useCreatePermission("PayorLabSetting");

  const labName = lab.labName ?? lab.dashboardDisplayName;
  const columns = useColumns({ labId, labName });

  const onAddLabPayorSettings = (message, details = []) => {
    const { refresh, setMessage } = tableRef.current;

    setMessage(message, details.length ? "warning" : "success", details);
    refresh();
  };

  return (
    <>
      <Toolbar className="align-items-center mb-3">
        <Toolbar className="ms-auto">
          <AdministrateBackgroundExportButton
            outline
            className="me-2"
            exportUrl={`/admin/labs/${labId}/payor_network_status/export`}
            filters={allFilters}
            ref={tableRef}
          />

          {canCreate && <ImportLabPayorSettingsModal outline className="me-2" onImport={onAddLabPayorSettings} labId={labId} />}
        </Toolbar>
      </Toolbar>

      <AdministrateTable
        resourceUrl={`/admin/labs/${labId}/payor_network_statuses.json`}
        resourceName={"payor_network_statuses"}
        onFilteredChange={setTableFilters}
        permissions={[UPDATE]}
        columns={columns}
        ref={tableRef}
      />
    </>
  );
};
